import * as React from 'react';

import { useConsumerMyPageHeader } from 'bundles/composable-page-header-consumer/contexts/ConsumerMyPageHeaderContext';
import SimplifiedMegaMenuWrapper from 'bundles/megamenu/components/SimplifiedMegaMenuWrapper';

const ExploreMegaMenuGridItem = () => {
  const { hasEnrolledPrograms, isCourseraPlusLearner } = useConsumerMyPageHeader();

  return (
    <div className="rc-ExploreMegaMenuGridItem">
      <SimplifiedMegaMenuWrapper shouldShowCourseraPlusButton={!isCourseraPlusLearner && !hasEnrolledPrograms} />
    </div>
  );
};

export default ExploreMegaMenuGridItem;
